<template>
  <div class="charts-action-group-button">
    <div class="dropdown">
      <button class="chart-title-action-group-btn" data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-haspopup="true" aria-expanded="false">
        <action-group-icon class="chart-title-action-group-icon" :fill="iconColor" />
      </button>
      <div class="dropdown-menu dropdown-menu-right">
        <button class="dropdown-item" type="button" @click="$emit('on-click-data-info')" :disabled="loadingDataInfo">
          <div class="icon-container">
            <data-info-icon v-if="!loadingDataInfo" />
            <div v-else>
              <div class="spinner-border" role="status">
                <span class="visually-hidden">{{ t('global.loading') }}</span>
              </div>
            </div>
          </div>
          {{ t('bi.data_info') }}
        </button>
        <button
          class="dropdown-item"
          type="button"
          @click="$emit('on-click-setting-chart')"
          :disabled="loadingSettingChart"
          v-permission="$can('portal-cdp', 'cdp-portal-dashboard-settinggraph')"
        >
          <div class="icon-container">
            <paint-bucket v-if="!loadingSettingChart" />
            <div v-else>
              <div class="spinner-border" role="status">
                <span class="visually-hidden">{{ t('global.loading') }}</span>
              </div>
            </div>
          </div>
          {{ t('bi.setting') }}
        </button>
        <button
          class="dropdown-item"
          type="button"
          @click="$emit('on-click-delete')"
          :disabled="loadingDelete"
          v-permission="$can('portal-cdp', 'cdp-portal-dashboard-deletegraph')"
        >
          <div class="icon-container">
            <delete-icon v-if="!loadingDelete" />
            <div v-else>
              <div class="spinner-border" role="status">
                <span class="visually-hidden">{{ t('global.loading') }}</span>
              </div>
            </div>
          </div>
          {{ t('bi.delete') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
//libs
import { useI18n } from 'vue-i18n';

//component
import ActionGroupIcon from '@/assets/icons/base/action-list/ActionGroupIcon.vue';

//icon
import PaintBucket from '@/assets/icons/modules/analytics/bi/PaintBucket.vue';
import DataInfoIcon from '@/assets/icons/modules/analytics/bi/DataInfoIcon.vue';
import DeleteIcon from '@/assets/icons/modules/analytics/bi/DeleteIcon.vue';

interface Props {
  iconColor: string;
  loadingDataInfo: boolean;
  loadingSettingChart: boolean;
  loadingDelete: boolean;
}

withDefaults(defineProps<Props>(), {
  iconColor: '#93adc1',
  loadingDataInfo: false,
  loadingSettingChart: false,
  loadingDelete: false,
});

const { t } = useI18n();
</script>

<style lang="scss" scoped>
.charts-action-group-button {
  .dropdown {
    position: relative;

    .chart-title-action-group-btn {
      border: none;
      background-color: unset;
      width: 2rem;
      transition: all 0.2s ease-in-out;

      &:hover {
        transform: scale(1.2);
      }
    }

    .dropdown-item {
      display: flex !important;
      align-items: center !important;
      justify-content: flex-start !important;

      &:active {
        background-color: #e9ecef !important;
        color: #626a6c;

        svg {
          fill: #626a6c;
        }
      }

      svg {
        fill: #626a6c;
        vertical-align: bottom;
        width: 100%;
      }

      .icon-container {
        height: 1.5rem;
        width: 1.5rem;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 0.75rem;

        .spinner-border {
          height: 1.25rem;
          width: 1.25rem;
        }
      }
    }

    .chart-title-action-group-icon {
      width: 5px;
    }

    .dropdown-menu {
      border-radius: 10px;
      inset: unset !important;
      transform: none !important;
      right: 0 !important;
      border: 1px solid #eaeaea;
      box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
    }
  }
}
</style>
